import { strategyToOptions } from '@/common/utils/strategyToOptions'

export const cardActivationMode = {
  automatically_on_first_consumption: 'Automaticamente no primeiro consumo',
  manual: 'Manual',
  manual_with_reason: 'Manual com justificativa'
}

export const cardActivationModeOptions = strategyToOptions(cardActivationMode)
